import React from 'react';

export function CircleSelected(props) {
    return (
        <svg viewBox="0 0 22 22" {...props}>
            <g fill="none" fillRule="evenodd" stroke="currentColor" transform="translate(1 1)">
                <circle cx={10} cy={10} r={10} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
                <circle cx={10} cy={10} r={2.5} fill="currentColor" strokeWidth={5} />
            </g>
        </svg>
    );
}
